import { Col, Divider, Input, Row } from 'antd';
import { debounce } from 'lodash';
import React, { useState } from 'react';

function IpsStationSection({
  handleProjectDetailUpdate,
  isReadOnly,
  project,
}) {
  const [removalBPID, setRemovalBPID] = useState(
    project ? project?.removalBPID : ''
  );
  const [removalWO, setRemovalWO] = useState(
    project ? project?.removalWO : ''
  );

  return (
    <>
      <Divider className='hr-border' />
      <section className='padding-container'>
        <Row>
          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 24,
            }}
            lg={{
              span: 12,
            }}
            xxl={{
              span: 12,
            }}
          >
            <Row className='spacing-bottom'>
              <Col
                className='key-title'
                xs={{
                  span: 5,
                }}
                sm={{
                  span: 5,
                }}
                md={{
                  span: 5,
                }}
                lg={{
                  span: 6,
                }}
                xxl={{
                  span: 4,
                }}
              >
                IPS Station Name :
              </Col>
              <Col>{project.stationName}</Col>
            </Row>
          </Col>
          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 24,
            }}
            lg={{
              span: 12,
            }}
            xxl={{
              span: 12,
            }}
          >
            <Row className='spacing-bottom '>
              <Col
                className='key-title '
                xs={{
                  span: 4,
                }}
                sm={{
                  span: 4,
                }}
                md={{
                  span: 5,
                }}
                lg={{
                  span: 6,
                }}
                xxl={{
                  span: 6,
                }}
              >
                Removal BPID :
              </Col>
              <Col>
                <Input
                  className='removal-input'
                  // maxLength={8}
                  // size="small"
                  disabled={isReadOnly}
                  value={removalBPID}
                  onBlur={() =>
                    handleProjectDetailUpdate(
                      removalBPID,
                      'REMOVAL_BPID',
                      'string'
                    )
                  }
                  onChange={(e) => setRemovalBPID(e.target.value)}
                />
              </Col>
            </Row>

            <Row className='spacing-bottom'>
              <Col
                className='key-title'
                xs={{
                  span: 4,
                }}
                sm={{
                  span: 4,
                }}
                md={{
                  span: 5,
                }}
                lg={{
                  span: 6,
                }}
                xxl={{
                  span: 6,
                }}
              >
                Removal Work Order :
              </Col>
              <Col>
                <Input
                  className='removal-input'
                  // maxLength={8}
                  // size="small"
                  disabled={isReadOnly}
                  value={removalWO}
                  onBlur={() =>
                    handleProjectDetailUpdate(removalWO, 'REMOVAL_WO', 'string')
                  }
                  onChange={(e) => setRemovalWO(e.target.value)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
}

export default IpsStationSection;
